import {
  ConversationLanguageCode,
  conversationLanguages,
} from 'lib-shared-languages';

import { LanguageSelectionListValue } from './useLanguageSelectionList.types';

/**
 * Converts a list of languages codes to language selector list value.
 *
 * @param codes The list of language codes.
 */
export function languageCodesToSelectionListValue(
  codes: readonly ConversationLanguageCode[],
): readonly LanguageSelectionListValue[] {
  return codes
    .map((code) =>
      conversationLanguages.find(
        (conversationLanguage) => conversationLanguage.code === code,
      ),
    )
    .filter(Boolean) as LanguageSelectionListValue[];
}
